import React, { useContext } from 'react';
import { DishFullInfoContext, IDishFullInfoContext } from '../../../../../../../dishFullInfoState/dishFullInfoContext';
import FullInfoField from 'components/FullInfoField/FullInfoField';

export const TaxPercent: React.FC = () => {
	const { dishForFullInfo } = useContext<IDishFullInfoContext>(DishFullInfoContext);

	return <FullInfoField label="taxRateLabel" value={dishForFullInfo?.taxPercent} />;
};
